import { render } from "./MyAccountPage.vue?vue&type=template&id=6469b7cc&scoped=true"
import script from "./MyAccountPage.vue?vue&type=script&lang=js"
export * from "./MyAccountPage.vue?vue&type=script&lang=js"

import "./MyAccountPage.vue?vue&type=style&index=0&id=6469b7cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6469b7cc"]])

export default __exports__